export default __webpack_public_path__ + "static/contact-7b1e321d4e018381cffb56e5a720c0dd.jpeg";